import { Flex, Text } from '@chakra-ui/react';
import SearchInput from '@components/common/SearchInput';
import { fakePredictionOpenOrders } from '@features/positions/predictions/fakeData';
import OpenOrdersTable from '@features/positions/predictions/OpenOrdersTable';
import PendingOrderDetailDialog from '@features/positions/predictions/PendingOrderDetailDialog';
import { PredictionOpenOrder } from '@features/positions/predictions/types';
import { memo, useCallback, useMemo, useState } from 'react';

const OpenOrdersTab = () => {
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedOrder, setSelectedOrder] = useState<PredictionOpenOrder | null>(null);

  const handleClear = useCallback(() => {
    setSearchQuery('');
  }, []);

  const handleRowClick = useCallback((order: PredictionOpenOrder) => {
    setSelectedOrder(order);
  }, []);

  const handleCloseDialog = useCallback(() => {
    setSelectedOrder(null);
  }, []);

  const filteredOrders = useMemo(() => {
    if (searchQuery.trim() === '') {
      return fakePredictionOpenOrders;
    }
    const q = searchQuery.toLowerCase();
    return fakePredictionOpenOrders.filter((o) => o.market.toLowerCase().includes(q));
  }, [searchQuery]);

  return (
    <Flex direction="column" gap={3}>
      <Flex direction="row" gap={2} alignItems="center" pt={3}>
        <SearchInput
          query={searchQuery}
          setQuery={setSearchQuery}
          onClear={handleClear}
          placeholder="Search"
          size="sm"
        />
      </Flex>
      {filteredOrders.length > 0 ? (
        <OpenOrdersTable orders={filteredOrders} onRowClick={handleRowClick} />
      ) : (
        <Text color="text.secondary" fontSize="sm" textAlign="center" py={8}>
          No pending orders found.
        </Text>
      )}
      <PendingOrderDetailDialog
        order={selectedOrder}
        open={selectedOrder != null}
        onClose={handleCloseDialog}
      />
    </Flex>
  );
};

export default memo(OpenOrdersTab);
